var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"dtx-btn",class:{
    'lg': _vm.size == 'lg',
    'md': _vm.size == 'md', 
    'sm': _vm.size == 'sm',
    'primary': _vm.variant == 'primary',
    'secondary': _vm.variant == 'secondary',
    'subtle': _vm.variant == 'subtle',
    'danger': _vm.variant == 'danger',
    'success': _vm.variant == 'success'},attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.isProcessing)?_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]}):_c('span',[_c('i',{class:['fa', _vm.selectedIcon, 'fa-spin']}),_vm._v(" "+_vm._s(_vm.busyLabel)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }